import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useUDData } from '@udemy/ud-data';
import { useHeaderStore } from '../../hooks/use-header-store';
import { MobileNavSection, MobileNavItem } from '../../mobile/mobile-nav/mobile-nav.react-component';
export const ManageAndTeachSection = observer(() => {
  const headerStore = useHeaderStore();
  const udConfig = useUDData().Config;
  const {
    isInstructor,
    user,
    organizationState
  } = headerStore.userSpecificContext;
  const {
    gettext
  } = useI18n();
  if (!user || !user.id) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MobileNavSection, null, udConfig.brand.is_teaching_enabled && isInstructor && /*#__PURE__*/React.createElement(MobileNavItem, {
    href: headerStore.urls.TEACH,
    color: "link"
  }, gettext('Switch to instructor view')), (organizationState === null || organizationState === void 0 ? void 0 : organizationState.should_show_manage_menu) && /*#__PURE__*/React.createElement(MobileNavItem, {
    cssToggleId: "header-toggle-side-nav-manage"
  }, gettext('Manage')));
});
//# sourceMappingURL=manage-and-teach-section.react-component.js.map